import { createContext, ReactNode, useContext, useEffect, useRef, useState } from "react";
import { useRouteLoaderData } from "react-router-dom";


type AuthenticationContextType = {
  version: number;
  isAuthenticated: boolean;
};

const AuthenticationContext = createContext<AuthenticationContextType | undefined>(undefined);

export function AuthenticationProvider({ children }: { children: ReactNode }) {

  const [ version, setVersion ] = useState(0);
  const lastLoggedInUserIdRef = useRef<number | undefined>(undefined);

  const currentAuth = useRouteLoaderData("auth") as { userId: number } | null;

  useEffect(() => {
    // only increase the version after successful authentication. if it's also incremented after failed authentication,
    // fetchers may try to reload data and will fail because of not being authenticated, obviously :)
    if (lastLoggedInUserIdRef.current !== currentAuth?.userId) {
      lastLoggedInUserIdRef.current = currentAuth?.userId;
      if (!!currentAuth?.userId) {
        setVersion(v => v + 1);
      }
    }
  }, [ currentAuth?.userId ]);

  return <AuthenticationContext.Provider value={ { version, isAuthenticated: !!currentAuth?.userId } }>{ children }</AuthenticationContext.Provider>;
}

export function useAuthenticationVersion() {
  const context = useContext(AuthenticationContext);

  return context ?? {
    version: 0,
    isAuthenticated: false
  };
}
